module.exports = __webpack_public_path__ + "img/knee.20012d17.png";